import React from "react";

import { Button, Icon } from "armstrong-react";
import { LinkButton } from "./../../core/atoms/atoms";
import { api } from "./../../shared/api/system/apiClient";

interface Props extends React.Props<GetAtolPdfButton> {
  enquiryId?: number;
  itineraryId: number;
  rounded?: boolean;
  inline?: boolean;
  text?: string;
  isAnchor?: boolean;
}

interface LocalState {
  jobId?: string;
  generating?: boolean;
  pdfUrl?: string;
}

export class GetAtolPdfButton extends React.Component<Props, LocalState> {
  private readonly pollInterval = 1000;

  constructor(props: Props) {
    super(props);
    this.state = { jobId: null, generating: false, pdfUrl: "" };
  }

  private async generateJob() {
    this.setState({ generating: true });
    try {
      const result = await api.generateAtolCertificateJob(this.props.enquiryId);
      this.setState({ jobId: (result.json as number).toString() }, () => {
        this.pollForChanges();
      });
    } catch (e) {
      // TODO make this better
      // tslint:disable-next-line:no-console
      console.error(e);
      this.setState({ generating: false, pdfUrl: null });
    }
  }

  private async pollForChanges() {
    try {
      const result = await api.pollPdfJob(this.state.jobId);
      const pollResponse = result.json;
      switch (pollResponse.status) {
        case PdfJobStatus.Done:
          this.setState({ generating: false, pdfUrl: pollResponse.url });
          break;
        case PdfJobStatus.Pending:
          window.setTimeout(() => {
            this.pollForChanges();
          }, this.pollInterval);
          break;
        case PdfJobStatus.Failed:
          this.setState({ generating: false, pdfUrl: "" });
          break;
      }
    } catch (e) {
      // TODO make this better
      // tslint:disable-next-line:no-console
      console.error(e);
      this.setState({ generating: false, pdfUrl: null });
    }
  }

  private renderAnchorTag = () => {
    if (this.state.pdfUrl) {
      return (
        <a style={{ display: this.props.inline ? "inline-block" : "block" }} href={this.state.pdfUrl} target={"_blank"}>
          <span>Open Certificate</span>
        </a>
      );
    }
    return (
      <a style={{ display: this.props.inline ? "inline-block" : "block" }}>
        {!this.state.pdfUrl &&
          <span onClick={() => this.generateJob()}>{`${this.state.generating ? "Please wait..." : this.props.text}`}</span>
        }
      </a>
    );
  }

  private renderButton = () => {
    return (
      <div className="generate-pdf-button" style={{ display: this.props.inline ? "inline-block" : "block" }}>
        {!this.state.pdfUrl &&
          <Button
          className="request-download"
          disabled={this.state.generating}
          leftIcon={Icon.Icomoon.filePdf} onClick={() => this.generateJob()}>{`${this.state.generating ? "Please wait..." : this.props.text}`}</Button>
        }
        {this.state.pdfUrl &&
          <LinkButton target="_blank" className="start-download" to={this.state.pdfUrl} icomoon={Icon.Icomoon.filePdf}>Open ATOL Certificate</LinkButton>
        }
      </div>
    );
  }

  public render() {
    if (this.props.isAnchor) {
      return (
        this.renderAnchorTag()
      );
    }
    return this.renderButton();
  }
}
